import { fNumber } from './formatNumber';

export const formatCanvassingDistance = (distance: number) => {
  return distance >= 5280 ? `${fNumber(distance / 5280)} mi` : `${fNumber(distance)} ft`;
};
